// Parse the URL
const getParameterByName = (a) => {
    var hashParams = window.location.hash ? window.location.hash.split('?')[1] : '';
    var params = window.location.search ? window.location.search : '?' + hashParams;
    console.log('Full URL:', window.location.href);
    console.log('Hash Params:', hashParams);
    console.log('Search Params:', params);
    var result = (a = params.match(new RegExp("[?&]" + a + "=([^&]*)(?=&?)", "i"))) ? a[1] : null;
    console.log('Parameter:', a, 'Result:', result);
    return result;
};

export const setTrackingCookie = () => {
    // Give the URL parameters variable names
    var txid = getParameterByName('txId');
    console.log('txId:', txid);

    // Set the cookies
    if (txid&&!/[^a-z0-9]/.test(txid)) {
        txid = txid.length>13?txid.substring(0, 13):txid;  
        var date = new Date();
        date.setTime(date.getTime()+ 2592000 * 100000);
        var expirationTime = date.toUTCString();
        document.cookie = "txid=" + txid + "; expires=" + expirationTime + "; path=/; domain=.now.com";
    }
};